import {Component, HostListener, OnInit, ViewChild, AfterContentChecked, ChangeDetectorRef} from '@angular/core';
import {AlertService} from '../../services/alert/alert.service';
import {ReportsService} from '../../services/reports/reports.service';
// import { Observable } from 'rxjs/Observable';
import {LoadingService} from '../../services/loading/loading.service';
// import * as FileSaver from 'file-saver';
// import { DownloadFileResponse } from '../../shared/common-components/file-storage/downloadFileResponse';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import _ from 'lodash';
import {FRTSummaryListFilter} from './frt-summary-list-filter';
import moment from 'moment';


@Component({
    selector: 'app-frt-summary-list',
    templateUrl: './frt-summary-list.component.html',
    styleUrls: ['./frt-summary-list.component.css'],
    standalone: false
})


export class FrtSummaryListComponent implements OnInit {
  public errorMessage = '';
  filterGroup: UntypedFormGroup;
  order = 'frt';
  reverse = false;
  // may need to improve searching results
  frt_filter: FRTSummaryListFilter = {
    beginDate: 0,
    endDate: Date.now()
  };
  private gridApi;
  strloader;
  paginationPageSize;
  domLayout;
  frtListDetails = [
    {}
  ];
  frtListColumnDefs = [
    {
      headerName: 'Agency Name',
      field: 'agencyName',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true
    },
    {
      headerName: 'Bureau Name',
      field: 'bureauName',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
    },
    {
      headerName: 'Bureau Creation Date',
      field: 'bureauCreationDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
      valueGetter: function (params) {
        return moment(params.data.bureauCreationDate).format('MM/DD/YYYY');
      }
    },
    {
      headerName: 'Auth Official Name (AO)',
      field: 'Roname',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: function (params) {
        return params.data.roLastName + ',' + params.data.roFirstName;
      }
    },
    {
      headerName: 'AO Location',
      field: 'roLocation',
      filter: 'agTextColumnFilter',
      sortable: true,
      type: 'leftaligned',
      width: 150,
      valueGetter: function (params) {
        return params.data.roCity + ',' + params.data.roStateCode;
      }
    },
    {
      headerName: 'AO Creation Date',
      field: 'roCreationDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: function (params) {
        return moment(params.data.roCreationDate).format('MM/DD/YYYY');
      }
    },
    {
      headerName: 'User Name',
      field: 'userName',
      filter: 'agTextColumnFilter',
      sortable: true,
      valueGetter: function (params) {
        return params.data.userLastName + ',' + params.data.userFirstName;
      }
    },
    {headerName: 'User Email', field: 'userContactEmail', filter: 'agTextColumnFilter', sortable: true, resizable: true, type: 'series'},
    {headerName: 'User Phone', field: 'userContactPhone', filter: 'agTextColumnFilter', sortable: true, width: 130, resizable: true},
    {
      headerName: 'User Creation Date',
      field: 'userCreationDate',
      filter: 'agTextColumnFilter',
      sortable: true,
      resizable: true,
      valueGetter: function (params) {
        return moment(params.data.userCreationDate).format('MM/DD/YYYY');
      }
    },
    {headerName: 'Total # Shipments', field: 'totalShipments', filter: 'agTextColumnFilter', sortable: true, resizable: true, chartDataType: 'category'},
    {headerName: 'Total Spend Amt', field: 'totalSpendAmt', filter: 'agTextColumnFilter', sortable: true, width: 150, resizable: true, chartDataType: 'series'}
  ];
  excelStyles = [
    {
      id: 'textFormat',
      dataType: 'string',
    }
  ];

  constructor(private reportsService: ReportsService,
              private alertService: AlertService,
              private loadingService: LoadingService,
              private cdref: ChangeDetectorRef,
              private fb: UntypedFormBuilder
  ) {
    this.paginationPageSize = 25;
  }

  ngOnInit() {
    this.generateFormGroupController();
    this.onSearch();
  }

  generateFormGroupController() {
    this.filterGroup = this.fb.group({
      fromDate: new UntypedFormControl(''),
      toDate: new UntypedFormControl('')
    });
  }

  seatchByFilter() {
    this.onSearch();
    const params = {
      force: true
    };
    this.gridApi.refreshCells(params);
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }

  onSearch() {
    this.frtListDetails = [];
    this.errorMessage = '';
    this.loadingService.show();
    const beginDate = new Date(this.filterGroup.get('fromDate').value).getTime();
    const endDate = new Date(this.filterGroup.get('toDate').value).getTime();
    this.reportsService.getFRTDetails(this.order, this.reverse, beginDate ? beginDate : this.frt_filter.beginDate, endDate ? endDate : this.frt_filter.endDate)
      .subscribe(data => {
          this.frtListDetails = data;
        }, (error) => {
          this.errorMessage = error;
          this.alertService.error('No records found for the search criteria ');
          this.loadingService.hide();
        }, () => {
          // console.log('Successfully retrieved frt list details: ', this.frtListDetails);
          this.loadingService.hide();
        }
      );
  }

  dateConverter(date: any) {
    return moment(date).format('MM/DD/YYYY');
  }

  setupPayload() {
    this.frt_filter.beginDate = (!_.isDate(this.filterGroup.get('fromDate').value)) ?
      0 : Date.parse(this.filterGroup.get('fromDate').value);
    this.frt_filter.endDate = (!_.isDate(this.filterGroup.get('toDate').value)) ?
      Date.now() : Date.parse(this.filterGroup.get('toDate').value);
  }

  resetFilter() {
    this.frt_filter.beginDate = null;
    this.frt_filter.endDate = null;
  }

  filterFromDateChange(formDate: any) {
    if (formDate === '' || formDate === null) {
    } else {
      if (!_.isDate(this.filterGroup.get('toDate').value)) {
        if (Date.parse(formDate) < Date.now()) {
          console.log('must be less than current date');
        }
      } else {
        if (formDate > this.filterGroup.get('toDate').value) {
          console.log('must be smaller');
        }
      }
    }
    this.filterGroup.get('fromDate').updateValueAndValidity();
  }

  filterToDateChange(toDate: any) {
    if (toDate === '' || toDate === null) {
    } else {
      if (!_.isDate(this.filterGroup.get('toDate').value)) {

      } else {
        if (!_.isDate(this.filterGroup.get('fromdate').value)) {
        } else {
          if (toDate > this.filterGroup.get('fromdate').value) {
            console.log('must be smaller');
          }
        }
      }
    }
    this.filterGroup.get('toDate').updateValueAndValidity();
  }

  turnOnvalidationFromDate() {
    this.filterGroup.get('fromdate').setValidators([Validators.required]);
  }

  turnOnvalidationToDate() {
    this.filterGroup.get('toDate').setValidators([Validators.required]);
  }
}
